module.exports = __webpack_public_path__ + "img/2_257.8924b1ed.png";